(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Function to wait for custom elements to be defined
  function waitForCustomElement(elementName, callback, maxAttempts = 50) {
    let attempts = 0;
    const checkElement = () => {
      attempts++;
      if (typeof customElements !== 'undefined' && customElements.get(elementName)) {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkElement, 100);
      } else {
      }
    };
    checkElement();
  }

  // Function to sync images from product page modals to footer modals
  // Always tries to sync if product modals exist, regardless of page type
  function syncModalImages() {
    try {
      const footerSizingModal = document.getElementById('UniversalSizingChartModalFooter');
      const footerPositionModal = document.getElementById('UniversalPositionChartModalFooter');
      
      // Helper function to check if footer modal already has images
      function hasImages(modal, imageWrapperClass) {
        if (!modal) return false;
        const imagesWrapper = modal.querySelector(`.${imageWrapperClass.replace('image-wrapper', 'images-wrapper')}`);
        if (imagesWrapper) {
          const hasImgTags = imagesWrapper.querySelectorAll('img').length > 0;
          const hasNoImagesMessage = imagesWrapper.innerHTML.includes('No ') && imagesWrapper.innerHTML.includes('images available');
          return hasImgTags && !hasNoImagesMessage;
        }
        return false;
      }
      
      // Helper function to copy images from product modal to footer modal
      function copyImagesToFooter(productModal, footerModal, imageWrapperClass, imagesWrapperClass) {
        if (!productModal || !footerModal) return false;
        
        const productImages = productModal.querySelectorAll(imageWrapperClass);
        const footerBody = footerModal.querySelector(imagesWrapperClass);
        
        if (productImages.length > 0 && footerBody) {
          // Clear existing content
          footerBody.innerHTML = '';
          
          // Copy images from product modal
          productImages.forEach((imgWrapper) => {
            footerBody.appendChild(imgWrapper.cloneNode(true));
          });
          
          // Update container class if multiple images
          const container = footerModal.querySelector(`.${imageWrapperClass.replace('image-wrapper', 'image-container')}`);
          if (container) {
            container.classList.toggle('has-multiple-images', productImages.length > 1);
          }
          return true;
        }
        return false;
      }
      
      // Sync sizing chart images - try multiple methods
      if (footerSizingModal && !hasImages(footerSizingModal, '.sizing-chart-image-wrapper')) {
        let synced = false;
        
        // Method 1: Try reading from popup section block data attributes (most reliable)
        const popupBlockContainer = document.querySelector('[data-sizing-chart-block="true"]');
        if (popupBlockContainer && !synced) {
          const imageUrls = [];
          for (let i = 1; i <= 5; i++) {
            const url = popupBlockContainer.getAttribute('data-chart-image-' + i);
            if (url && url.trim() !== '') {
              imageUrls.push(url);
            }
          }
          
          if (imageUrls.length > 0) {
            const footerBody = footerSizingModal.querySelector('.sizing-chart-modal-body');
            if (footerBody) {
              // Remove empty message div completely
              const emptyDiv = footerBody.querySelector('.sizing-chart-empty');
              if (emptyDiv) {
                emptyDiv.remove();
              }
              
              // Ensure protocol is added to URLs if missing
              const fullUrls = imageUrls.map(url => {
                if (url.startsWith('//')) {
                  return window.location.protocol + url;
                }
                return url;
              });
              
              let imagesWrapper = footerBody.querySelector('.sizing-chart-images');
              if (!imagesWrapper) {
                imagesWrapper = document.createElement('div');
                imagesWrapper.className = 'sizing-chart-images sizing-chart-images-wrapper' + (fullUrls.length > 1 ? ' has-multiple' : '');
                footerBody.appendChild(imagesWrapper);
              }
              
              imagesWrapper.innerHTML = '';
              fullUrls.forEach((imgUrl) => {
                const imgWrapper = document.createElement('div');
                imgWrapper.className = 'sizing-chart-image-wrapper';
                const img = document.createElement('img');
                img.src = imgUrl;
                img.className = 'sizing-chart-image';
                img.alt = 'Size Guide';
                img.loading = 'lazy';
                img.style.width = '100%';
                img.style.height = 'auto';
                img.style.display = 'block';
                imgWrapper.appendChild(img);
                imagesWrapper.appendChild(imgWrapper);
              });
              synced = true;
            }
          }
        }
        
        // Method 2: Try direct ID first
        if (!synced) {
          const productSizingModal = document.getElementById('UniversalSizingChartModal');
          if (productSizingModal) {
            synced = copyImagesToFooter(productSizingModal, footerSizingModal, '.sizing-chart-image-wrapper', '.sizing-chart-modal-body .sizing-chart-images-wrapper');
          }
        }
        
        if (!synced) {
          // Try to find modal near button
          const sizingButton = document.querySelector('.product-sizing-chart-button');
          if (sizingButton) {
            const buttonParent = sizingButton.closest('.product-sizing-chart-wrapper');
            if (buttonParent) {
              const nearbyModal = buttonParent.querySelector('modal-dialog');
              if (nearbyModal && nearbyModal.id !== 'UniversalSizingChartModalFooter') {
                synced = copyImagesToFooter(nearbyModal, footerSizingModal, '.sizing-chart-image-wrapper', '.sizing-chart-modal-body .sizing-chart-images-wrapper');
              }
              
              // If still not synced, try reading from data attributes
              if (!synced) {
                const images = [];
                for (let i = 1; i <= 5; i++) {
                  const imgUrl = buttonParent.getAttribute(`data-chart-image-${i}`);
                  if (imgUrl && imgUrl !== '') {
                    images.push(imgUrl);
                  }
                }
                
                if (images.length > 0) {
                  const footerBody = footerSizingModal.querySelector('.sizing-chart-modal-body');
                  if (footerBody) {
                    const emptyDiv = footerBody.querySelector('.sizing-chart-empty');
                    if (emptyDiv) emptyDiv.remove();
                    
                    let imagesWrapper = footerBody.querySelector('.sizing-chart-images');
                    if (!imagesWrapper) {
                      imagesWrapper = document.createElement('div');
                      imagesWrapper.className = 'sizing-chart-images sizing-chart-images-wrapper' + (images.length > 1 ? ' has-multiple' : '');
                      footerBody.appendChild(imagesWrapper);
                    }
                    
                    imagesWrapper.innerHTML = '';
                    images.forEach((imgUrl) => {
                      const imgWrapper = document.createElement('div');
                      imgWrapper.className = 'sizing-chart-image-wrapper';
                      const img = document.createElement('img');
                      img.src = imgUrl;
                      img.className = 'sizing-chart-image';
                      img.loading = 'lazy';
                      img.alt = 'Size Guide';
                      imgWrapper.appendChild(img);
                      imagesWrapper.appendChild(imgWrapper);
                    });
                    synced = true;
                  }
                }
              }
            }
          }
        }
      }
      
      // Sync position chart images - try multiple methods
      if (footerPositionModal && !hasImages(footerPositionModal, '.position-chart-image-wrapper')) {
        let synced = false;
        
        // Method 1: Try reading from popup section block data attributes (most reliable)
        const popupBlockContainer = document.querySelector('[data-position-chart-block="true"]');
        if (popupBlockContainer && !synced) {
          const imageUrls = [];
          for (let i = 1; i <= 5; i++) {
            const url = popupBlockContainer.getAttribute('data-chart-image-' + i);
            if (url && url.trim() !== '') {
              imageUrls.push(url);
            }
          }
          
          if (imageUrls.length > 0) {
            const footerBody = footerPositionModal.querySelector('.position-chart-modal-body');
            if (footerBody) {
              const emptyDiv = footerBody.querySelector('.position-chart-empty');
              if (emptyDiv) emptyDiv.remove();
              
              // Ensure protocol is added to URLs if missing
              const fullUrls = imageUrls.map(url => {
                if (url.startsWith('//')) {
                  return window.location.protocol + url;
                }
                return url;
              });
              
              let imagesWrapper = footerBody.querySelector('.position-chart-images');
              if (!imagesWrapper) {
                imagesWrapper = document.createElement('div');
                imagesWrapper.className = 'position-chart-images position-chart-images-wrapper' + (fullUrls.length > 1 ? ' has-multiple' : '');
                footerBody.appendChild(imagesWrapper);
              }
              
              imagesWrapper.innerHTML = '';
              fullUrls.forEach((imgUrl) => {
                const imgWrapper = document.createElement('div');
                imgWrapper.className = 'position-chart-image-wrapper';
                const img = document.createElement('img');
                img.src = imgUrl;
                img.className = 'position-chart-image';
                img.alt = 'Position Guide';
                img.loading = 'lazy';
                img.style.width = '100%';
                img.style.height = 'auto';
                img.style.display = 'block';
                imgWrapper.appendChild(img);
                imagesWrapper.appendChild(imgWrapper);
              });
              synced = true;
            }
          }
        }
        
        // Method 2: Try direct ID first
        if (!synced) {
          const productPositionModal = document.getElementById('UniversalPositionChartModal');
          if (productPositionModal) {
            synced = copyImagesToFooter(productPositionModal, footerPositionModal, '.position-chart-image-wrapper', '.position-chart-modal-body .position-chart-images-wrapper');
          }
        }
        
        // Method 3: Try to find modal near button
        if (!synced) {
          const positionButton = document.querySelector('.product-position-chart-button');
          if (positionButton) {
            const buttonParent = positionButton.closest('.product-position-chart-wrapper');
            if (buttonParent) {
              const nearbyModal = buttonParent.querySelector('modal-dialog');
              if (nearbyModal && nearbyModal.id !== 'UniversalPositionChartModalFooter') {
                synced = copyImagesToFooter(nearbyModal, footerPositionModal, '.position-chart-image-wrapper', '.position-chart-modal-body .position-chart-images-wrapper');
              }
              
              // If still not synced, try reading from data attributes on product wrapper
              if (!synced) {
                const images = [];
                for (let i = 1; i <= 5; i++) {
                  const imgUrl = buttonParent.getAttribute(`data-chart-image-${i}`);
                  if (imgUrl && imgUrl !== '') {
                    images.push(imgUrl);
                  }
                }
                
                if (images.length > 0) {
                  const footerBody = footerPositionModal.querySelector('.position-chart-modal-body');
                  if (footerBody) {
                    const emptyDiv = footerBody.querySelector('.position-chart-empty');
                    if (emptyDiv) emptyDiv.remove();
                    
                    // Ensure protocol is added to URLs if missing
                    const fullUrls = images.map(url => {
                      if (url.startsWith('//')) {
                        return window.location.protocol + url;
                      }
                      return url;
                    });
                    
                    let imagesWrapper = footerBody.querySelector('.position-chart-images');
                    if (!imagesWrapper) {
                      imagesWrapper = document.createElement('div');
                      imagesWrapper.className = 'position-chart-images position-chart-images-wrapper' + (fullUrls.length > 1 ? ' has-multiple' : '');
                      footerBody.appendChild(imagesWrapper);
                    }
                    
                    imagesWrapper.innerHTML = '';
                    fullUrls.forEach((imgUrl) => {
                      const imgWrapper = document.createElement('div');
                      imgWrapper.className = 'position-chart-image-wrapper';
                      const img = document.createElement('img');
                      img.src = imgUrl;
                      img.className = 'position-chart-image';
                      img.loading = 'lazy';
                      img.alt = 'Position Guide';
                      img.style.width = '100%';
                      img.style.height = 'auto';
                      img.style.display = 'block';
                      imgWrapper.appendChild(img);
                      imagesWrapper.appendChild(imgWrapper);
                    });
                    synced = true;
                  }
                }
              }
            }
          }
        }
      }
    } catch (error) {
      // Error handled silently
    }
  }

  // Function to find and open modal with retries
  function findAndOpenModal(hash, retries = 10) {
    if (retries <= 0) {
      return;
    }
    
    // Sync images from product page modals before opening
    syncModalImages();

    let modal = null;
    
    if (hash === 'universal-size-chart') {
      // Try multiple selectors in order of preference
      modal = document.querySelector('modal-dialog[data-modal-hash="universal-size-chart"]');
      if (!modal) {
        modal = document.querySelector('#UniversalSizingChartModalFooter');
      }
      if (!modal) {
        modal = document.querySelector('#UniversalSizingChartModal');
      }
      // Also try finding by tag name and checking attributes
      if (!modal) {
        const allModals = document.querySelectorAll('modal-dialog');
        for (let m of allModals) {
          if (m.getAttribute('data-modal-hash') === 'universal-size-chart' || 
              m.id === 'UniversalSizingChartModalFooter' || 
              m.id === 'UniversalSizingChartModal') {
            modal = m;
            break;
          }
        }
      }
    } else if (hash === 'universal-position-chart') {
      // Try multiple selectors in order of preference
      modal = document.querySelector('modal-dialog[data-modal-hash="universal-position-chart"]');
      if (!modal) {
        modal = document.querySelector('#UniversalPositionChartModalFooter');
      }
      if (!modal) {
        modal = document.querySelector('#UniversalPositionChartModal');
      }
      // Also try finding by tag name and checking attributes
      if (!modal) {
        const allModals = document.querySelectorAll('modal-dialog');
        for (let m of allModals) {
          if (m.getAttribute('data-modal-hash') === 'universal-position-chart' || 
              m.id === 'UniversalPositionChartModalFooter' || 
              m.id === 'UniversalPositionChartModal') {
            modal = m;
            break;
          }
        }
      }
    }

    if (modal && typeof modal.show === 'function') {
      try {
        if (!document.body.contains(modal)) {
          document.body.appendChild(modal);
        }
        if (!modal.hasAttribute('open')) {
          modal.show();
        }
        return true; // Success
      } catch (error) {
        // Error opening modal
        setTimeout(() => findAndOpenModal(hash, retries - 1), 200);
        return false;
      }
    } else if (retries > 0) {
      // Modal not found yet, try to find a button that opens it
      let openerButton = null;
      if (hash === 'universal-size-chart') {
        openerButton = document.querySelector('modal-opener[data-modal="#UniversalSizingChartModalFooter"] button, modal-opener[data-modal="#UniversalSizingChartModal"] button');
      } else if (hash === 'universal-position-chart') {
        openerButton = document.querySelector('modal-opener[data-modal="#UniversalPositionChartModalFooter"] button, modal-opener[data-modal="#UniversalPositionChartModal"] button');
      }
      
      if (openerButton) {
        try {
          openerButton.click();
          return true; // Success
        } catch (error) {
          // Error clicking modal opener
        }
      }
      
      // Retry finding modal
      setTimeout(() => findAndOpenModal(hash, retries - 1), 200);
    }
    return false;
  }

  // Function to initialize hash modal opening
  function initHashModal() {
    const hash = window.location.hash.substring(1);
    if (!hash || (hash !== 'universal-size-chart' && hash !== 'universal-position-chart')) {
      return;
    }

    // Wait for custom element to be defined first
    waitForCustomElement('modal-dialog', () => {
      // Try to find and open the modal
      findAndOpenModal(hash);
    });
  }

  // Initialize when page loads - try multiple times
  function tryInitHashModal() {
    const hash = window.location.hash.substring(1);
    if (hash === 'universal-size-chart' || hash === 'universal-position-chart') {
      initHashModal();
    }
  }

  // Try immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitHashModal);
  } else {
    tryInitHashModal();
  }

  // Also try after window load (all scripts loaded)
  window.addEventListener('load', () => {
    setTimeout(tryInitHashModal, 100);
  });

  // Also check hash when navigating (for hash changes)
  window.addEventListener('hashchange', () => {
    const hash = window.location.hash.substring(1);
    if (hash === 'universal-size-chart' || hash === 'universal-position-chart') {
      waitForCustomElement('modal-dialog', () => {
        findAndOpenModal(hash);
      });
    }
  });

  // Sync images once when DOM is ready (on all pages, in case product modals exist)
  function initModalImageSync() {
    // Wait a bit for modals to be rendered
    setTimeout(() => {
      syncModalImages();
    }, 500);
    // Also try again after a longer delay in case modals load slowly
    setTimeout(() => {
      syncModalImages();
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalImageSync);
  } else {
    initModalImageSync();
  }

  // Also sync when modals are opened
  document.addEventListener('click', (e) => {
    if (e.target.closest('modal-opener[data-modal="#UniversalSizingChartModalFooter"]') || 
        e.target.closest('modal-opener[data-modal="#UniversalPositionChartModalFooter"]')) {
      setTimeout(() => {
        syncModalImages();
      }, 100);
    }
  });
  
  // Also sync when modals are opened via show() method
  if (typeof customElements !== 'undefined' && customElements.get('modal-dialog')) {
    const ModalDialogClass = customElements.get('modal-dialog');
    const originalShowMethod = ModalDialogClass.prototype.show;
    ModalDialogClass.prototype.show = function() {
      if (this.id === 'UniversalSizingChartModalFooter' || this.id === 'UniversalPositionChartModalFooter') {
        setTimeout(() => {
          syncModalImages();
        }, 100);
      }
      return originalShowMethod.call(this);
    };
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  // Function to wait for custom element to be defined
  function waitForModalDialog(callback, maxAttempts = 50) {
    let attempts = 0;
    const checkElement = () => {
      attempts++;
      if (typeof customElements !== 'undefined' && customElements.get('modal-dialog')) {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkElement, 100);
      }
    };
    checkElement();
  }

  // Function to open modal by hash with retries
  function openModalByHash(retries = 5) {
    if (retries <= 0) return;
    
    const hash = window.location.hash.substring(1);
    let modal = null;
    let modalId = null;
    
    if (hash === 'universal-size-chart') {
      modalId = 'UniversalSizingChartModalFooter';
      // Try multiple ways to find the modal
      modal = document.getElementById(modalId);
      if (!modal) {
        // Try by data-modal-hash attribute
        modal = document.querySelector('modal-dialog[data-modal-hash="universal-size-chart"]');
      }
      if (!modal) {
        // Try any modal-dialog with the ID
        modal = document.querySelector('modal-dialog#' + modalId);
      }
    } else if (hash === 'universal-position-chart') {
      modalId = 'UniversalPositionChartModalFooter';
      // Try multiple ways to find the modal
      modal = document.getElementById(modalId);
      if (!modal) {
        // Try by data-modal-hash attribute
        modal = document.querySelector('modal-dialog[data-modal-hash="universal-position-chart"]');
      }
      if (!modal) {
        // Try any modal-dialog with the ID
        modal = document.querySelector('modal-dialog#' + modalId);
      }
    }
    
    if (modal) {
      // Ensure modal is in the DOM and visible
      if (!document.body.contains(modal)) {
        document.body.appendChild(modal);
      }
      
      // Make sure modal is not hidden by parent
      let parent = modal.parentElement;
      while (parent && parent !== document.body) {
        if (parent.style.display === 'none' || parent.classList.contains('popup') && !parent.classList.contains('popup-open')) {
          // Modal is in a hidden popup, move it to body
          document.body.appendChild(modal);
          break;
        }
        parent = parent.parentElement;
      }
      
      if (typeof modal.show === 'function') {
        try {
          modal.show();
          return true;
        } catch (e) {
          console.log('Error opening modal:', e);
        }
      }
      
      // Fallback: try to find and click the opener button
      const opener = document.querySelector('modal-opener[data-modal="#' + modalId + '"] button, button[data-modal="#' + modalId + '"]');
      if (opener) {
        opener.click();
        return true;
      }
      
      // Another fallback: try to set open attribute
      if (modal.setAttribute) {
        modal.setAttribute('open', '');
        return true;
      }
    } else if (retries > 0) {
      // Modal not found yet, retry
      setTimeout(() => openModalByHash(retries - 1), 300);
    }
    
    return false;
  }

  // Initialize when modal-dialog is ready
  function initHashModal() {
    waitForModalDialog(function() {
      // Check hash on page load
      const checkHash = () => {
        const hash = window.location.hash.substring(1);
        if (hash === 'universal-size-chart' || hash === 'universal-position-chart') {
          setTimeout(() => openModalByHash(5), 100);
        }
      };
      
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkHash);
      } else {
        checkHash();
      }

      // Check hash on hash change
      window.addEventListener('hashchange', function() {
        setTimeout(() => openModalByHash(5), 100);
      });
    });
  }

  // Start initialization immediately (don't wait for modal-dialog)
  function tryOpenModalImmediately() {
    const hash = window.location.hash.substring(1);
    if (hash === 'universal-size-chart' || hash === 'universal-position-chart') {
      openModalByHash(5);
    }
  }

  // Try immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryOpenModalImmediately);
  } else {
    tryOpenModalImmediately();
  }

  // Also initialize with proper waiting
  initHashModal();

  // Also listen for clicks on links with these hashes
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href*="#universal-size-chart"], a[href*="#universal-position-chart"]');
    if (link) {
      const href = link.getAttribute('href');
      const hash = href.split('#')[1];
      if (hash) {
        // Update hash
        window.location.hash = hash;
        // Try to open immediately
        setTimeout(() => openModalByHash(5), 100);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
